import { supabase } from '@/lib/supabase';

export const fetchNotificationsService = async (shopId: string | number) => {
    try {
        const { data, error } = await supabase
            .from('Notifications')
            .select('*')
            .eq('shop_id', shopId)
            .order('created_at', { ascending: false });

        if (error) {
            throw new Error(`Errore DB: ${error.message}`);
        }

        return { success: true, data: data || [], error: '' };
    } catch (error: any) {
        console.error('Errore nel recupero delle notifiche:', error?.message);
        return { success: false, data: [], error: error?.message };
    }
};

export const updateNotificationService = async (id: number, read: boolean) => {
    try {
        const { error } = await supabase
            .from('Notifications')
            .update({ read })
            .eq('id', id);

        if (error) throw new Error(`Errore DB: ${error.message}`);

        return { success: true, error: '' };
    } catch (error: any) {
        console.error(
            "Errore nell'aggiornamento della notifica:",
            error?.message,
        );
        return { success: false, error: error?.message };
    }
};
